import { autoinject, bindable, observable } from 'aurelia-framework';
import { ErrorService } from 'services/error-service';
import { ValidationController, ValidationRules, Validator } from 'aurelia-validation';
import { I18N } from 'aurelia-i18n';
import { CertificateProducer, MooringSupplier } from 'models/mooring/MooringSupplier';

@autoinject
export class MooringSupplierCreateEdit {
  @bindable
  @observable
  model: MooringSupplier = new MooringSupplier();
  modelChanged(model: MooringSupplier) {
    if (!model) return;
    this.form = JSON.parse(JSON.stringify(model));
  }

  @bindable
  onSave: (data: { data: MooringSupplier }) => void;

  @bindable
  onCanceled: () => void;

  @bindable
  @observable
  visible = false;

  protected form: MooringSupplier = {
    Id: undefined,
    Name: undefined,
    CertifiedProducer: false,
    CertificateProducer: 1,
  };

  constructor(
    private t: I18N,
    private validator: Validator,
    private errorService: ErrorService,
    private validationController: ValidationController
  ) {}

  protected applyValidationRules() {
    ValidationRules.ensure('Name').required().withMessage(this.t.tr('general.requiredField')).on(this.form);
  }

  attached() {
    this.applyValidationRules();
  }

  protected setCertificateProducer(producer: 'morenot' | 'supplier') {
    this.form.CertificateProducer = producer === 'morenot' ? CertificateProducer.MORENOT : CertificateProducer.SUPPLIER;
    this.form = { ...this.form };
  }

  private async validate() {
    this.applyValidationRules();
    await this.validator.validateObject(this.form);
    return (await this.validationController.validate({ object: this.form })).valid;
  }

  async save() {
    try {
      const valid = await this.validate();
      if (!valid) return;
      this.onSave?.({ data: this.form });
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  cancel() {
    this.onCanceled?.();
  }
}
